import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { INgxSelectOption } from 'ngx-select-ex';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SeqTemplate, SeqTemplateData, TypeOptions } from '../../../@core/interfaces/masters/sequenceTemplate';
import { TenantPackageData } from '../../../@core/interfaces/masters/tenantpackage';
import { ToastrAppSrvcService } from '../../../_services/toastr-app-srvc.service';
import { messages } from '../../../data/page_messages';
import * as dateFormat from './../../../data/sequence-template-date-format.json';
import * as pageList from './../../../data/sequence-template-pages.json';
import { access } from '../../../data/access-constants';
import { RolesData } from '../../../@core/interfaces/common/roles';


@Component({
  selector: 'ngx-sequence-template',
  templateUrl: './sequence-template.component.html',
  styleUrls: ['./sequence-template.component.css']
})
export class SequenceTemplateComponent implements OnInit {

  dateFormatOptions: string[] = (dateFormat as any).default;
  placeholder: string = "Select";
  allowClear: any = true;
  dClear: any = false;
  multiple: boolean = false;
  isSubmitted: boolean = false;
  format1RadioSelection: number = 0;
  format2RadioSelection: number = 0;
  format3RadioSelection: number = 0;
  formt1TextDisable: boolean = null;
  formt2TextDisable: boolean = null;
  formt3TextDisable: boolean = null;
  formt1NumberDisable: boolean = null;
  formt2NumberDisable: boolean = null;
  formt3NumberDisable: boolean = null;
  formt1DateDisable: boolean = null;
  formt2DateDisable: boolean = null;
  formt3DateDisable: boolean = null;
  public tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  page_hint:string=messages.page_hints.UniqueIdgenerator;
  sequenceeTemplateForm: FormGroup;
  datetime = new Date(Date.now());
  protected readonly unsubscribe$ = new Subject<void>();
  flag: boolean;
  sortOrder: string;
  numberStart: number;
  textFormat: string;
  dateFormat: string;
  saveData: SeqTemplate;
  setNumberValidation: boolean = false;
  data: any;
  currentVal: number = 0;
  currentdate: Date = new Date(Date.now());
  updateData: any;
  previewText: string = "";
  disableSave: boolean = false;
  isAddComponent: boolean = true;
  nod: any = 8;
  textcheck: boolean = true;
  datecheck: boolean = true;
  districtCheck:boolean=false;
  preview: string = "";
  formvalue: any;
  limitflag: boolean = false;
  datelimitflag: boolean = false;
  numlimitflag: boolean = false;
  textlen: any = 0
  datelen: any = 0
  datestart: any = 0;
  textstart: any = 0;
  numstart: any = 7
  numlen: any = 1
  pageOptions: Array<any> = [];
  typeOptions: TypeOptions[] = [
    { title: 'Text', value: 1 },
    { title: 'Date Format', value: 2 }
  ];
  isErrorMsg: boolean = false;
  isTextErrorMsg: boolean = false;
  isDateErrorMsg: boolean = false;
  nodLimitflag: boolean = false;
  successLabel: boolean = false;
  updateLabel: boolean = false;
  tenantPackageId: any;
  isPreview: boolean = false;
  branchList: Array<any> = [];
  previewArrayText: Array<any> = [];
  branchCodeList: Array<any> = [];
  seqSettings: any;
  updateBranchList: any;
  previewDataList: any;
  isChange: boolean;
  showType: boolean = false;
  districtFlag:boolean=false;
  deleteFlag:boolean=false;
  fieldCheck:boolean=false;
  digitEnd:boolean=false;
  digitSpace:string='';
  separators:string='';
  Customization:boolean=false;
  FormattedText:string;


  constructor(private rolesService:RolesData,
    protected router: Router, private datePipe: DatePipe,
    protected tenantpackageSrvc: TenantPackageData, private tstSrvc: ToastrAppSrvcService, private fb: FormBuilder, protected seqTemplateSrvc: SeqTemplateData, private toasterService: NbToastrService) {

    this.sequenceeTemplateForm = this.fb.group({
      increment: this.fb.control(1, [Validators.required, Validators.min(1)]),
      length: this.fb.control(10, [Validators.required, Validators.min(1)]),
      pageList: this.fb.control(null, [Validators.required]),
      pad: this.fb.control(0, [Validators.required, Validators.maxLength(1)]),
      format1: this.fb.control("Empty", []),
      format2: this.fb.control("Empty", []),
      format3: this.fb.control("Empty", []),
      format1date: this.fb.control(null, []),
      format1number: this.fb.control(null, [Validators.required, Validators.min(0)]),
      format1text: this.fb.control(null, [Validators.pattern('^[A-Za-z]+$')]),
      format2date: this.fb.control(null, []),
      format2number: this.fb.control(null, [Validators.min(0)]),
      format2text: this.fb.control(null, [Validators.pattern('^[A-Za-z]+$')]),
      format3date: this.fb.control(null, []),
      format3number: this.fb.control(null, [Validators.min(0)]),
      format3text: this.fb.control(null, [Validators.pattern('^[A-Za-z]+$')]),
      prefix: this.fb.control("Text"),
      type: this.fb.control("tenantbased", [Validators.required]),
      separators:this.fb.control(null,[Validators.pattern(/^[-\/()&:]+$/)]),
    }, {
      validators: [NumberFormatExistsValidator("format1", "format2", "format3"), format1Validator("format1", "format1date", "format1number", "format1text"),
      format2Validator("format2", "format2date", "format2number", "format2text"), , format3Validator("format3", "format3date", "format3number", "format3text"),
      ]
    });
  }

  ngOnInit(): void {
    this.setNumberValidation = false;
    this.ResetRadioButton();
    this.fetchSeqTemplate();
    this.checkPackageId();
    this.pageaccess();
    this.sequenceeTemplateForm.valueChanges
      .subscribe((value) => {
        this.formvalue = value;
      });
    this.sequenceeTemplateForm.controls['format1number'].setValue(1)
    this.preview = "00000001"
  }
  onClose() {
    this.router.navigate(['/pages/masters/dashboard']);
  }
  get fval(): { [key: string]: AbstractControl } { return this.sequenceeTemplateForm.controls; }
  typeChange(event, value) {
    let dateFormat;
    let dateValue="";
    let branchCodeLength = 0;
    if (this.sequenceeTemplateForm.get('format1text').value != null)
      this.textlen = this.sequenceeTemplateForm.get('format1text').value?.length;
    else
      this.textlen = 0
    
    let district =0;
    if(this.districtCheck)
      district=5;
    else
      district =0;

    if (this.sequenceeTemplateForm.get('format1date').value != null) {
      dateFormat = this.sequenceeTemplateForm.get('format1date').value;

      dateValue = this.datePipe.transform(Date.now(), dateFormat);
      this.datelen = dateValue.length;
    }
    else
      this.datelen = 0;

    if (value == "branchbased") {
      this.nod = this.nod + 4;
      branchCodeLength = 4;
    }
    else {
      this.nod = this.nod - 4;
      branchCodeLength = 0;
    }

    let fText = "";
    if (this.sequenceeTemplateForm.get('prefix').value == "Date Format") {
      fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
      fText = dateValue + "" + fText;
      let tempCount = this.nod - branchCodeLength - district;
      let remainingLength = tempCount - fText?.length;

      let numVal = this.sequenceeTemplateForm.get('format1number').value;
      remainingLength = remainingLength - numVal.toString().length;
      let padVal = ""
      for (var t = 0; t < remainingLength; t++) {
        padVal = padVal + "0";
      }
      if(this.districtCheck)
        fText = fText + "" + padVal + ""+"ERODE" + numVal;
      else
      fText = fText + "" + padVal + "" + numVal;


    }
    else {
      fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
      fText = fText + "" + dateValue;
      let tempCount = this.nod - branchCodeLength - district;
      let remainingLength = tempCount - fText?.length;

      let numVal = this.sequenceeTemplateForm.get('format1number').value;
      remainingLength = remainingLength - numVal.toString().length;
      let padVal = ""
      for (var t = 0; t < remainingLength; t++) {
        padVal = padVal + "0";
      }
      if(this.districtCheck){
        if(this.sequenceeTemplateForm.get('prefix').value == "District")
          fText = "ERODE"+""+fText + "" + padVal + "" + numVal;
        else
          fText = fText + "" + padVal + "" +"ERODE"+ numVal;
      }else
          fText = fText + "" + padVal + "" + numVal;


    }


    if (value == "branchbased") {
      this.previewArrayText.length = 0;
      this.branchList.forEach(element => {
        let ptext = element.branchCode + "/" + fText.toUpperCase();
        let previewData={
          code: element.area,
          pValue:ptext
        }

        this.previewArrayText.push(previewData);
      });
    }
    else {
      this.previewArrayText.length = 0;
      let previewData={
        code: "EMPTY",
        pValue:fText.toUpperCase()
      }
      this.previewArrayText.push(previewData);
    }


  }
  onTypeSelect(event: INgxSelectOption[]): void {
    this.disableSave = false;
    this.isErrorMsg = false;
    this.isTextErrorMsg = false;
    this.isDateErrorMsg = false;
    this.nodLimitflag = false;
    this.limitflag = false;
    this.datelimitflag = false;
    let key = event[0].data.value;
    this.isPreview = false;
    if(event[0].data.isbranch == 'true')
    this.showType = true;
    else
    this.showType = false;
    this.seqTemplateSrvc.getById(`${this.apiUrl}/tenants/${this.tenantId}/seqtemplate/${key}/previewwithdata`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.isChange = false;

      this.previewArrayText.length = 0;
      this.seqSettings = data.seqSettings;
      data.seqTemplate.forEach(element => {
        if (element.currentValue > 0)
          this.disableSave = true;
      });
     
      if(data.seqTemplate.length > 0)
      {
      this.updateData = data.seqTemplate[0];


      }
      else
      this.updateData = null;
      this.updateBranchList = data.seqTemplate;

      this.previewDataList = data.preview;
    }, (error) => {
      this.isSubmitted = false;
      this.FormReset();
    }, () => {
      this.isSubmitted = false;
      this.FormReset();
      if(!!this.seqSettings && this.updateData?.sortOrder.includes('A')){
        // this.updateData.length = this.updateData?.length - 5;
        this.districtCheck=false;
        this.districtdisable();
        this.districtFlag=true;
      }
      else{
        this.districtFlag=false;
        this.districtCheck=false;
      }
      if(event[0].data.value=='REG'||event[0].data.value=='UNREG'){
        this.districtFlag=true;
      }
      this.loadUpdateData(this.updateData);
      if(this.previewDataList?.length > 0)
      {
      setTimeout(() => {
        this.previewArrayText.length = 0
        this.previewDataList.forEach(element => {
          let val="EMPTY";
          if(element.includes("/"))
           val= this.branchList.find(e=>e.branchCode == element.split("/",1)[0])?.area;
           else
           val=val;
          let previewData={
            code: val,
            pValue:element.toUpperCase()
          }

          this.previewArrayText.push(previewData);
        });
        this.numberchange();
        if (this.previewArrayText.length > 0)
          {this.isPreview = true;}
        if(!!this.updateData?.separator && this.updateData?.separator !='null'){
        this.Customization = true;
        this.FormattedText = this.applySeparators(this.previewArrayText[0]?.pValue,JSON.parse(this.updateData?.separator));}
      }, 500);
    
    }
    });
  }
  FormReset() {
    this.ResetRadioButton();
    this.format1RadioSelection = 0;
    this.format2RadioSelection = 0;
    this.format3RadioSelection = 0;
    this.sequenceeTemplateForm.controls['format1'].setValue("Empty");
    this.sequenceeTemplateForm.controls['format2'].setValue("Empty");
    this.sequenceeTemplateForm.controls['format3'].setValue("Empty");
    this.sequenceeTemplateForm.controls['increment'].setValue(1);
    this.sequenceeTemplateForm.controls['length'].setValue(8);
    this.sequenceeTemplateForm.controls['pad'].setValue(0);
    this.sequenceeTemplateForm.controls['format1date'].setValue(null);
    this.sequenceeTemplateForm.controls['format1number'].setValue(1);
    this.sequenceeTemplateForm.controls['format1text'].setValue(null);
    this.sequenceeTemplateForm.controls['format2date'].setValue(null);
    this.sequenceeTemplateForm.controls['format2number'].setValue(null);
    this.sequenceeTemplateForm.controls['format2text'].setValue(null);
    this.sequenceeTemplateForm.controls['format3date'].setValue(null);
    this.sequenceeTemplateForm.controls['format3number'].setValue(null);
    this.sequenceeTemplateForm.controls['format3text'].setValue(null);
    this.sequenceeTemplateForm.controls['format1number'].setValue(1);
    this.sequenceeTemplateForm.controls['type'].setValue("tenantbased");
    this.textcheck = true;
    this.datecheck = true;
    this.limitflag = false;
    this.datelimitflag = false;
    this.numlimitflag = false;
    this.typeOptions = [];
    this.typeOptions.push({ "title": "Text", "value": 1 });
    this.typeOptions.push({ "title": "Date Format", "value": 2 });
    this.sequenceeTemplateForm.controls['prefix'].setValue("")
    if(this.districtCheck)
      this.districtdisable();

    //this.sequenceeTemplateForm.controls["prefix"].setValue("Text")
    this.nod = 8;

    this.preview = "00000001"
    this.previewArrayText.length = 0;
    let previewData={
      code: "EMPTY",
      pValue:"00000001"
    }
    this.previewArrayText.push(previewData);
    this.isPreview = true;
   // this.previewArrayText.push("00000001");
    //debugger
  }

  checkPackageId() {

    this.tenantpackageSrvc.tenantList(`tenantPackage/GetTenantBranchDuplicate/${this.tenantId}/${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((tenPackage: any) => {

      this.tenantPackageId = tenPackage[0].packageId;

      if (this.tenantPackageId != 'd19d155c-b7f6-4ec7-f912-08d91b5217a8') {
        this.pageOptions = (pageList as any).default;

      } else {
        this.pageOptions = [{
          "title": "Registration",
          "value": "REG"
        },
        {
          "title": "OP Bill",
          "value": "OPBILL"
        },
        {
          "title": "Receipt",
          "value": "RCPT"
        }]
      }
    }, (error) => {

    }, () => {

    });

  }



  loadUpdateData(data) {
    if (data != null && data != undefined) {
      // this.ResetRadioButton();
      this.nod = data?.length;
      if (this.seqSettings != null)
        this.sequenceeTemplateForm.controls['type'].setValue(this.seqSettings.sequenceType);
      else
        this.sequenceeTemplateForm.controls['type'].setValue("tenantbased");
      this.sequenceeTemplateForm.controls['increment'].setValue(data.increment);
      this.sequenceeTemplateForm.controls['length'].setValue(data.length);
      //this.sequenceeTemplateForm.controls['pageList'].setValue(data.keyword);
      if (data.textDesc != null && data.textDesc != undefined)
        this.sequenceeTemplateForm.controls['format1text'].setValue(data.textDesc);
      else
        this.sequenceeTemplateForm.controls['format1text'].setValue(null);

      if (data.dateFormat != null && data.dateFormat != undefined)
        this.sequenceeTemplateForm.controls['format1date'].setValue(data.dateFormat);
      else
        this.sequenceeTemplateForm.controls['format1date'].setValue(null);

      if (data.numberStart != null && data.numberStart != undefined)
        this.sequenceeTemplateForm.controls['format1number'].setValue(data.numberStart);
      else
        this.sequenceeTemplateForm.controls['format1number'].setValue(null);
      let sort = data.sortOrder;
      if (data?.sortOrder?.length == 3) {
        this.typeOptions = [];
        this.textcheck = true;
        this.datecheck = true;
        this.typeOptions.push({ "title": "Text", "value": 1 });
        this.typeOptions.push({ "title": "Date Format", "value": 2 });
        if (sort == "TDN") {
          this.sequenceeTemplateForm.controls['prefix'].setValue("Text");
        }
        else if (sort == "DTN") {
          this.sequenceeTemplateForm.controls['prefix'].setValue("Date Format");
        }
      }
      else if (data?.sortOrder?.length == 2) {
        this.typeOptions = [];
        if (sort == "TN") {
          this.typeOptions.push({ "title": "Text", "value": 1 });
          this.textcheck = true;
          this.datecheck = false;
          this.sequenceeTemplateForm.controls['prefix'].setValue("Text");
        }
        else if (sort == "DN") {
          this.textcheck = false;
          this.datecheck = true;
          this.typeOptions.push({ "title": "Date Format", "value": 2 });

          this.sequenceeTemplateForm.controls['prefix'].setValue("Date Format");
        }

      }else if(data?.sortOrder?.length == 4) {
        this.typeOptions = [];
        this.textcheck = true;
        this.datecheck = true;
        this.typeOptions.push({ "title": "Text", "value": 1 });
        this.typeOptions.push({ "title": "Date Format", "value": 2 });
        if (sort == "TDAN") {
          this.sequenceeTemplateForm.controls['prefix']?.setValue("Text");
        }
        else if (sort == "DTAN") {
          this.sequenceeTemplateForm.controls['prefix']?.setValue("Date Format");
        }else if( sort == "ATDN"){
          this.sequenceeTemplateForm.controls['prefix']?.setValue('District');
        }

      }
      else {
        this.typeOptions = [];
        this.districtCheck=false;
        this.textcheck = false;
        this.datecheck = false;
      }
    }
    else {
      this.FormReset();
    }
  }

  fetchSeqTemplate(): void {
    this.isSubmitted = false;

    this.seqTemplateSrvc.list(`tenants/${this.tenantId}/seqtemplate/withbranch`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.data = data.sequnceTemplate;
      this.branchList = data.branchList;
      this.branchCodeList.length = 0;
      this.branchList.forEach(element => {
        let branchData = {
          code: element.branchCode,
          branchId: element.id
        }
        this.branchCodeList.push(branchData);
      });

    }, (error) => {

    }, () => {

    });
  }

  ResetRadioButton() {
    this.formt1DateDisable = null;
    this.formt2DateDisable = null;
    this.formt3DateDisable = null;
    this.formt1TextDisable = null;
    this.formt2TextDisable = null;
    this.formt3TextDisable = null;
    this.formt1NumberDisable = null;
    this.formt2NumberDisable = null;
    this.formt3NumberDisable = null;

  }
  SetF1(value) {
    switch (value) {
      case "Empty":
        break;
      case "Text Format":
        {
          this.formt2TextDisable = true;
          this.formt3TextDisable = true;
          break;
        }
      case "Date Format":
        {
          this.formt2DateDisable = true;
          this.formt3DateDisable = true;
          break;
        }
      case "Number":
        {
          this.formt2NumberDisable = true;
          this.formt3NumberDisable = true;
          break;
        }

    }
  }
  SetF2(value) {
    switch (value) {
      case "Empty":
        break;
      case "Text Format":
        {
          this.formt1TextDisable = true;
          this.formt3TextDisable = true;
          break;
        }
      case "Date Format":
        {
          this.formt1DateDisable = true;
          this.formt3DateDisable = true;
          break;
        }
      case "Number":
        {
          this.formt1NumberDisable = true;
          this.formt3NumberDisable = true;
          break;
        }

    }
  }
  SetF3(value) {
    switch (value) {
      case "Empty":
        break;
      case "Text Format":
        {
          this.formt1TextDisable = true;
          this.formt2TextDisable = true;
          break;
        }
      case "Date Format":
        {
          this.formt1DateDisable = true;
          this.formt2DateDisable = true;
          break;
        }
      case "Number":
        {
          this.formt1NumberDisable = true;
          this.formt2NumberDisable = true;
          break;
        }

    }
  }
  setPreviewForDropdown(event, args) {
    if (args == "format3date") {
      this.sequenceeTemplateForm.controls['format3date'].setValue(event[0].value);
      this.setPreview();
    }
    else if (args == "format2date") {
      this.sequenceeTemplateForm.controls['format2date'].setValue(event[0].value);
      this.setPreview();
    }
  }
  setPreview() {
    let f1 = this.sequenceeTemplateForm.get('format1').value;
    let f2 = this.sequenceeTemplateForm.get('format2').value;
    let f3 = this.sequenceeTemplateForm.get('format3').value;
    let length = this.sequenceeTemplateForm.get('length').value;
    let f1Value = "";
    let f2Value = "";
    let f3Value = "";
    let preview = "";
    let dateLength: number = 0;
    let numberLength: number = 0;
    let textLength: number = 0;
    let padData = "";

    if (f1 == "Text Format") {
      f1Value = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
      textLength = this.sequenceeTemplateForm.get('format1text').value?.length;
      preview += f1Value;
    }

    if (f2 == "Date Format") {
      let dateFormat = this.sequenceeTemplateForm.get('format2date').value;
      f2Value = this.datePipe.transform(Date.now(), dateFormat);
      //f2Value = datef2;
      dateLength = f2Value.length;
    }
    else if (f2 == "Number") {
      f2Value = this.sequenceeTemplateForm.get('format2number').value;
      numberLength = f2Value.toString().length;
    }

    if (f3 == "Date Format") {
      let dateFormat = this.sequenceeTemplateForm.get('format3date').value;
      f3Value = this.datePipe.transform(Date.now(), dateFormat);
      //f3Value = datef3.toDateString();
      dateLength = f3Value.length;
    }
    else if (f3 == "Number") {
      f3Value = this.sequenceeTemplateForm.get('format3number').value;
      numberLength = f3Value.toString().length;
    }




    let totalLength = textLength + dateLength + numberLength;
    if (totalLength > length) {
      //exceeds
      this.previewText = "Limit Exceeds";
    }
    else {


      let tempLength = length - totalLength;
      let padAppendLength = tempLength;
      for (let i = 0; i < padAppendLength; i++) {
        padData += "0";
      }


      if (f2 == "Date Format" || "Empty") {
        preview += f2Value;
        padData += f3Value;
        preview += padData;
      }
      else if (f2 == "Number") {
        padData += f2Value;
        preview += f2Value;
        preview += f3Value;
      }
      this.previewText = preview;
    }





  }
  nodChange(val) {
    let checkVal = 0;
    let isProceed = false;
    let branchLen =0;
    let distrct=0;
    let datelength=0;
    if (this.sequenceeTemplateForm.get('format1date').value != null) {
      let dateFormat = this.sequenceeTemplateForm.get('format1date').value;

      let dateValue = this.datePipe.transform(Date.now(), dateFormat);
      datelength = dateValue.length;
    }
    else
      datelength = 0;
    if(this.districtCheck)
      distrct=5
    else
      distrct=0
    if (this.sequenceeTemplateForm.get('type').value == "branchbased"){
      checkVal = 12;
      branchLen = 4
    }
    else{
      checkVal = 8;
      branchLen = 0;
    }
    let len=0;
    if (this.sequenceeTemplateForm.get('format1number').value != null)
      len = this.sequenceeTemplateForm.get('format1number').value.toString().length;
    else
      len = 0;

    if (val == "increase") {
      if (this.nod < this.sequenceeTemplateForm.get('format1text').value?.length + datelength + len + branchLen + distrct ) {
        isProceed = true;
        this.nod = this.nod + 1;

      }
      else
        isProceed = false;
    }
    else
    {
      if (this.nod > checkVal && this.nod > this.sequenceeTemplateForm.get('format1text').value?.length + datelength + len + branchLen + distrct ) {
        isProceed = true;
        this.nod = this.nod - 1;

      }
      else
        isProceed = false;
    }


    if (isProceed) {

      this.numstart = this.nod - 1;
      this.limitCheck();
      if (this.limitflag == false && this.datelimitflag == false && this.nodLimitflag == false) {
        let fText = "";
        let branchCodeLength = 0;
        let dateFormat ;
        let dateValue="";
        if(this.sequenceeTemplateForm.get('format1date').value != null)
        {
        dateFormat = this.sequenceeTemplateForm.get('format1date').value;

        dateValue = this.datePipe.transform(Date.now(), dateFormat);
        }

        if (this.sequenceeTemplateForm.get('type').value == "branchbased")
          branchCodeLength = 4;
        else
          branchCodeLength = 0;

          let district =0;
          if(this.districtCheck)
            district=5;
          else
            district =0;

        if (this.sequenceeTemplateForm.get('prefix').value == "Date Format") {
          fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
          fText = dateValue + "" + fText;
          let tempCount = this.nod - branchCodeLength - district;
          let remainingLength = tempCount - fText?.length;

          let numVal = this.sequenceeTemplateForm.get('format1number').value;
          remainingLength = remainingLength - numVal.toString().length;
          let padVal = ""
          for (var t = 0; t < remainingLength; t++) {
            padVal = padVal + "0";
          }
          // fText = fText + "" + padVal + "" + numVal;
          if(this.districtCheck){
            fText = fText + "" + padVal + "" +'ERODE'+ "" +numVal;
          }else{
            fText = fText + "" + padVal + "" + numVal;
          }


        }
        else {
          fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
          fText = fText + "" + dateValue;
          let tempCount = this.nod - branchCodeLength - district;
          let remainingLength = tempCount - fText?.length;

          let numVal = this.sequenceeTemplateForm.get('format1number').value;
          remainingLength = remainingLength - numVal.toString().length;
          let padVal = ""
          for (var t = 0; t < remainingLength; t++) {
            padVal = padVal + "0";
          }
          // fText = fText + "" + padVal + "" + numVal;
          if(this.districtCheck){
            if(this.sequenceeTemplateForm.get('prefix').value == "District")
              fText = "ERODE"+ fText + "" + padVal+"" + numVal;
            else
              fText = fText + "" + padVal + "" +'ERODE'+ "" +numVal;
            // fText = fText + "" + padVal + "" +'ERODE'+ "" +numVal;
          }else{
            fText = fText + "" + padVal + "" + numVal;
          }


        }


        if (this.sequenceeTemplateForm.get('type').value == "branchbased") {
          this.previewArrayText.length = 0;
          this.branchList.forEach(element => {
            let ptext = element.branchCode + "/" + fText.toUpperCase();
            let previewData={
              code: element.area,
              pValue:ptext
            }

            this.previewArrayText.push(previewData);
          });
        }
        else {
          this.previewArrayText.length = 0;
          let previewData={
            code: "EMPTY",
            pValue:fText.toUpperCase()
          }
          this.previewArrayText.push(previewData);
        }

      }
    }
  }
  decreasenod() {
    if (this.nod > 8) {
      this.nod = this.nod - 1;
      this.numstart = this.nod - 1;
      this.limitCheck();
      if (this.limitflag == false && this.datelimitflag == false && this.nodLimitflag == false) {
        this.preview = ""
        var out = this.preview.split('')
        for (var i = 0; i < (this.nod - 1); i++) {
          out[i] = '0'
        }
        out[this.nod - 1] = '1'
        this.preview = out.join("")
      }
    }
  }

  formatChange(event, arg) {
    this.ResetRadioButton();
    let f1 = this.sequenceeTemplateForm.get('format1').value;
    let f2 = this.sequenceeTemplateForm.get('format2').value;
    let f3 = this.sequenceeTemplateForm.get('format3').value;
    this.SetF1(f1);
    this.SetF2(f2);
    this.SetF3(f3);
    let x = event.target.value;
    if (arg == 'format1') {
      if (x == 'Empty')
        this.format1RadioSelection = 1;

      else if (x == 'Text Format') {
        this.format1RadioSelection = 3;
      }
      else if (x == 'Date Format')
        this.format1RadioSelection = 2;
      else if (x == 'Number')
        this.format1RadioSelection = 4;



    }
    else if (arg == 'format2') {
      if (x == 'Empty')
        this.format2RadioSelection = 1;
      else if (x == 'Text Format')
        this.format2RadioSelection = 3;
      else if (x == 'Date Format')
        this.format2RadioSelection = 2;
      else if (x == 'Number')
        this.format2RadioSelection = 4;
      else
        this.format3RadioSelection = 0;
    }
    else if (arg == 'format3') {
      if (x == 'Empty')
        this.format3RadioSelection = 1;
      else if (x == 'Text Format')
        this.format3RadioSelection = 3;
      else if (x == 'Date Format')
        this.format3RadioSelection = 2;
      else if (x == 'Number')
        this.format3RadioSelection = 4;
      else
        this.format3RadioSelection = 0;
    }
    this.setPreview();
    var target = event.target;
  }
  getSortOrder(): string {
    let sorting = "";
    var f1 = this.sequenceeTemplateForm.get('format1').value;
    let f2 = this.sequenceeTemplateForm.get('format2').value;
    let f3 = this.sequenceeTemplateForm.get('format3').value;
    if (f1 != "Empty" && f1 != null && f1 != undefined && f1 != "") {
      sorting += f1.charAt(0);
    }
    if (f2 != "Empty" && f2 != null && f2 != undefined && f2 != "") {
      sorting += f2.charAt(0);
    }
    if (f3 != "Empty" && f3 != null && f3 != undefined && f3 != "") {
      sorting += f3.charAt(0);
    }
    return sorting;
  }
  getNumberStart(): number {
    let value;
    if (this.sequenceeTemplateForm.get('format1number').value != null && this.sequenceeTemplateForm.get('format1number').value != undefined && this.sequenceeTemplateForm.get('format1number').value != "") {
      value = this.sequenceeTemplateForm.get('format1number').value;
    }
    else if (this.sequenceeTemplateForm.get('format2number').value != null && this.sequenceeTemplateForm.get('format2number').value != undefined && this.sequenceeTemplateForm.get('format2number').value != "") {
      value = this.sequenceeTemplateForm.get('format2number').value;
    }
    else if (this.sequenceeTemplateForm.get('format3number').value != null && this.sequenceeTemplateForm.get('format3number').value != undefined && this.sequenceeTemplateForm.get('format3number').value != "") {
      value = this.sequenceeTemplateForm.get('format3number').value;
    }
    return value;
  }
  getTextFormat(): string {
    let value;
    if (this.sequenceeTemplateForm.get('format1text').value != null && this.sequenceeTemplateForm.get('format1text').value != undefined && this.sequenceeTemplateForm.get('format1text').value != "") {
      value = this.sequenceeTemplateForm.get('format1text').value;
    }
    else if (this.sequenceeTemplateForm.get('format2text').value != null && this.sequenceeTemplateForm.get('format2text').value != undefined && this.sequenceeTemplateForm.get('format2text').value != "") {
      value = this.sequenceeTemplateForm.get('format2text').value;
    }
    else if (this.sequenceeTemplateForm.get('format3text').value != null && this.sequenceeTemplateForm.get('format3text').value != undefined && this.sequenceeTemplateForm.get('format3text').value != "") {
      value = this.sequenceeTemplateForm.get('format3text').value;
    }
    return value;
  }
  getDateFormat(): string {
    let value;
    if (this.sequenceeTemplateForm.get('format1date').value != null && this.sequenceeTemplateForm.get('format1date').value != undefined && this.sequenceeTemplateForm.get('format1date').value != "") {
      value = this.sequenceeTemplateForm.get('format1date').value;
    }
    else if (this.sequenceeTemplateForm.get('format2date').value != null && this.sequenceeTemplateForm.get('format2date').value != undefined && this.sequenceeTemplateForm.get('format2date').value != "") {
      value = this.sequenceeTemplateForm.get('format2date').value;
    }
    else if (this.sequenceeTemplateForm.get('format3date').value != null && this.sequenceeTemplateForm.get('format3date').value != undefined && this.sequenceeTemplateForm.get('format3date').value != "") {
      value = this.sequenceeTemplateForm.get('format3date').value;
    }
    return value;
  }
  get apiUrl(): string {
    return environment.apiUrl;
  }
  isDataAlreadyExits(validateData): boolean {
    this.flag = false;
    if (this.data != null && this.data != undefined && this.data.length != 0) {
      //let val = this.getValue(data).complaintId;
      let val = this.data.filter(x=>x.keyword == validateData);
      if(val.length > 0)
      {
        this.flag = true;

        val.forEach(element => {
          if (element.keyword == validateData) {
            this.currentVal = element.currentValue;
            this.currentdate = element.entryDatatime;
          }
        });
      }
   
    }
    return this.flag;
  }
  textdisable() {
    this.textcheck = !this.textcheck;
    if (this.textcheck)
      this.typeOptions.push({ "title": "Text", "value": 1 });
    else
    {
    this.sequenceeTemplateForm.controls['format1text'].setValue("");
    this.typeOptions.forEach((value,index)=>{
      if(value.value==1) this.typeOptions.splice(index,1);
  });
   if(this.typeOptions.length == 1)
   this.sequenceeTemplateForm.controls['prefix'].setValue(this.typeOptions[0].title);
    }
  }
  datedisable() {
    this.datecheck = !this.datecheck;
    if (this.datecheck) { this.typeOptions.push({ "title": "Date Format", "value": 2 }); }
    else
    {
      this.sequenceeTemplateForm.controls['format1date'].setValue("");
      this.typeOptions.forEach((value,index)=>{
        if(value.value==2) this.typeOptions.splice(index,1);
    });
     if(this.typeOptions.length == 1)
     this.sequenceeTemplateForm.controls['prefix'].setValue(this.typeOptions[0].title);
    }
  }
  districtdisable(){
    this.districtCheck = !this.districtCheck;
     if (this.districtCheck) { 
      this.typeOptions.push({ "title": "District", "value": 3 }); 
      let branchCodeLength = 0;
    if (this.sequenceeTemplateForm.get('type').value == "branchbased")
      branchCodeLength = 4;
    else
      branchCodeLength = 0;
    let dateFormat;
    let dateValue ="";
    if (this.sequenceeTemplateForm.get('format1text').value != null)
      this.textlen = this.sequenceeTemplateForm.get('format1text').value?.length;
    else
      this.textlen = 0
    if (this.sequenceeTemplateForm.get('format1date').value != null) {
      dateFormat = this.sequenceeTemplateForm.get('format1date')?.value;

      dateValue = this.datePipe?.transform(Date.now(), dateFormat);
      this.datelen = dateValue?.length;
    }
    else
      this.datelen = 0;
    let numVal = this.sequenceeTemplateForm.get('format1number').value?.toString().length;
    let district=5;
    if(this.nod > this.textlen+this.datelen+numVal+district+branchCodeLength){
      let remaining =this.nod - (this.textlen+this.datelen+numVal+district) ;

    }else{
      let remaining = (this.textlen+this.datelen+numVal+district+branchCodeLength) - this.nod;
      this.nod += remaining;
    }
    }
    else
    {
      //this.sequenceeTemplateForm.controls['format1date'].setValue("");
      this.typeOptions.forEach((value,index)=>{
        if(value?.value==3) this.typeOptions.splice(index,1);
    });
     if(this.typeOptions?.length == 1)
     this.sequenceeTemplateForm.controls['prefix'].setValue('District');
    }
    if(!!this.sequenceeTemplateForm.get('format1text').value)
      this.textchange();
    else if(!!this.sequenceeTemplateForm.get('format1date').value)
      this.datechange(this.sequenceeTemplateForm.get('format1date').value);
    else
      this.numberchange();
  
  }
  textchange() {
    this.limitflag = false;
    let branchCodeLength = 0;
    let district =0;
    if(this.districtCheck)
      district=5;
    else
      district =0;
    if (this.sequenceeTemplateForm.get('type').value == "branchbased")
      branchCodeLength = 4;
    else
      branchCodeLength = 0;
    let dateFormat;
    let dateValue ="";
    if (this.sequenceeTemplateForm.get('format1text').value != null)
      this.textlen = this.sequenceeTemplateForm.get('format1text').value?.length;
    else
      this.textlen = 0
    if (this.sequenceeTemplateForm.get('format1date').value != null) {
      dateFormat = this.sequenceeTemplateForm.get('format1date').value;

      dateValue = this.datePipe.transform(Date.now(), dateFormat);
      this.datelen = dateValue.length;
    }
    else
      this.datelen = 0;
    if (this.textlen > 0) {
      this.isTextErrorMsg=false;
      if (this.textlen + this.datelen + this.numlen + branchCodeLength + district > (this.nod))
        this.limitflag = true;
      else {
        let fText = "";
        if (this.sequenceeTemplateForm.get('prefix').value == "Date Format") {
          fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
          fText = dateValue + "" + fText;
          let tempCount = this.nod - branchCodeLength - district;
          let remainingLength = tempCount - fText?.length;

          let numVal = this.sequenceeTemplateForm.get('format1number').value;
          remainingLength = remainingLength - numVal.toString().length;
          let padVal = ""
          for (var t = 0; t < remainingLength; t++) {
            padVal = padVal + "0";
          }
          // fText = fText + "" + padVal + "" + numVal;
          if(this.districtCheck){
            fText = fText + "" + padVal+"ERODE"+ "" + numVal;
          }else{
            fText = fText + "" + padVal + "" + numVal;
          }

        }
        else {
          fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
          fText = fText + "" + dateValue;
          let tempCount = this.nod - branchCodeLength - district;
          let remainingLength = tempCount - fText?.length;

          let numVal = this.sequenceeTemplateForm.get('format1number').value;
          remainingLength = remainingLength - numVal.toString().length;
          let padVal = ""
          for (var t = 0; t < remainingLength; t++) {
            padVal = padVal + "0";
          }
          // fText = fText + "" + padVal + "" + numVal;
          if(this.districtCheck){
            if(this.sequenceeTemplateForm.get('prefix').value == "District")
              fText = "ERODE"+fText + "" + padVal+"" + numVal;
            else
              fText = fText + "" + padVal+"ERODE"+ "" + numVal;
          }else{
            fText = fText + "" + padVal + "" + numVal;
          }
        }



        if (this.sequenceeTemplateForm.get('type').value == "branchbased") {
          this.previewArrayText.length = 0;
          this.branchList.forEach(element => {
            let ptext = element.branchCode + "/" + fText.toUpperCase();
            let previewData={
              code: element.area,
              pValue:ptext
            }

            this.previewArrayText.push(previewData);
          });
        }
        else {
          this.previewArrayText.length = 0;
          let previewData={
            code: "EMPTY",
            pValue:fText.toUpperCase()
          }
          this.previewArrayText.push(previewData);
        }
      }
    }
    this.resetCustom();
  }
  datechange(event: any) {
    this.datelimitflag = false;
    if (event?.length > 0 || !!event ) {
      this.isDateErrorMsg=false;
      let branchCodeLength = 0;
      if (this.sequenceeTemplateForm.get('type').value == "branchbased")
        branchCodeLength = 4;
      else
        branchCodeLength = 0;
      
      let district =0;
        if(this.districtCheck)
          district=5;
        else
          district =0;


      let dateFormat = event[0]?.value || (event?.length > 0 ?event:'');
      let dateValue = this.datePipe?.transform(Date?.now(), dateFormat);
      this.datelen = dateValue?.length;

      if (this.sequenceeTemplateForm.get('format1text').value != null)
        this.textlen = this.sequenceeTemplateForm.get('format1text').value?.length;
      else
        this.textlen = 0;
      if (this.textlen + this.datelen + this.numlen + branchCodeLength + district > (this.nod))
        this.datelimitflag = true;
      else {
        let fText;
        if (this.sequenceeTemplateForm.get('prefix').value == "Date Format") {
          fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
          fText = dateValue + "" + fText;
          let tempCount = this.nod - branchCodeLength - district;
          let remainingLength = tempCount - fText?.length;

          let numVal = this.sequenceeTemplateForm.get('format1number').value;
          remainingLength = remainingLength - numVal.toString().length;
          let padVal = ""
          for (var t = 0; t < remainingLength; t++) {
            padVal = padVal + "0";
          }
          // fText = fText + "" + padVal + "" + numVal;
          if(this.districtCheck){
            fText = fText + "" + padVal+"ERODE"+ "" + numVal;
          }else{
            fText = fText + "" + padVal + "" + numVal;
          }

        }
        else {
          fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
          fText = fText + "" + dateValue;
          let tempCount = this.nod - branchCodeLength - district;
          let remainingLength = tempCount - fText?.length;

          let numVal = this.sequenceeTemplateForm.get('format1number').value;
          remainingLength = remainingLength - (numVal.toString()?.length);
          let padVal = ""
          for (var t = 0; t < remainingLength; t++) {
            padVal = padVal + "0";
          }
          // fText = fText + "" + padVal + "" + numVal;
          if(this.districtCheck){
            if(this.sequenceeTemplateForm.get('prefix').value == "District")
              fText = "ERODE"+''+fText + "" + padVal+"" + numVal;
            else
              fText = fText + "" + padVal+"ERODE"+ "" + numVal;
          }else{
            fText = fText + "" + padVal + "" + numVal;
          }

        }

        if (this.sequenceeTemplateForm.get('type').value == "branchbased") {
          this.previewArrayText.length = 0;
          this.branchList.forEach(element => {
            let ptext = element.branchCode + "/" + fText.toUpperCase();
            let previewData={
              code: element.area,
              pValue:ptext
            }

            this.previewArrayText.push(previewData);
          });
        }
        else {
          this.previewArrayText.length = 0;
          let previewData={
            code: "EMPTY",
            pValue:fText.toUpperCase()
          }
          this.previewArrayText.push(previewData);
        }
      }
    }
    this.resetCustom();
  }
  numberchange() {

    this.numlimitflag = false;
    let branchCodeLength = 0;
    let dateFormat;
    let dateValue="";
    let fText = "";
    let district =0;
    if(this.districtCheck)
      district=5;
    else
      district =0;
    if (this.sequenceeTemplateForm.get('type').value == "branchbased")
      branchCodeLength = 4;
    else
      branchCodeLength = 0;

    if (this.sequenceeTemplateForm.get('format1text').value != null)
      this.textlen = this.sequenceeTemplateForm.get('format1text').value?.length;
    else
      this.textlen = 0;

    if (this.sequenceeTemplateForm.get('format1date').value != null) {
      dateFormat = this.sequenceeTemplateForm.get('format1date').value;

      dateValue = this.datePipe.transform(Date.now(), dateFormat);
      this.datelen = dateValue?.length;
    }
    else
      this.datelen = 0;

    let len;
    if (this.sequenceeTemplateForm.get('format1number').value != null)
      len = this.sequenceeTemplateForm.get('format1number')?.value?.toString()?.length;
    else
      len = 0;
    this.numlen = len;
    if (this.textlen + this.datelen + len + branchCodeLength +district > (this.nod))
      this.numlimitflag = true;
    else {

      if (this.sequenceeTemplateForm.get('prefix').value == "Date Format") {
        fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
        fText = dateValue + "" + fText;
        let tempCount = this.nod - branchCodeLength - district;
        let remainingLength = tempCount - fText?.length;

        let numVal = !!this.sequenceeTemplateForm.get('format1number')?.value?this.sequenceeTemplateForm.get('format1number').value:'';
        remainingLength = remainingLength - numVal?.toString()?.length;
        let padVal = ""
        for (var t = 0; t < remainingLength; t++) {
          padVal = padVal + "0";
        }
        if(this.districtCheck)
          fText =fText + "" + padVal +"ERODE"+ "" +numVal;
        else
          fText = fText + "" + padVal + "" + numVal;


      }
      else if (this.sequenceeTemplateForm.get('prefix').value == "Text") {
        fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
        fText = fText + "" + dateValue;
        let tempCount = this.nod - branchCodeLength - district;
        let remainingLength = tempCount - fText?.length;

        let numVal = !!this.sequenceeTemplateForm.get('format1number').value?this.sequenceeTemplateForm.get('format1number').value:'';
        remainingLength = remainingLength - numVal?.toString()?.length;
        let padVal = ""
        for (var t = 0; t < remainingLength; t++) {
          padVal = padVal + "0";
        }

        // fText = fText + "" + padVal + "" + numVal;
        if(this.districtCheck){
          fText =fText + "" + padVal +"ERODE"+ "" +numVal;
        }else{
          fText = fText + "" + padVal + "" + numVal;
        }


      }
      else {
        fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
        fText = fText + "" + dateValue;
        let tempCount = this.nod - branchCodeLength - district - fText?.length ;
        let numVal = !!this.sequenceeTemplateForm.get('format1number').value?this.sequenceeTemplateForm.get('format1number').value:'';
        let remainingLength = tempCount - numVal?.toString()?.length;
        let padVal = ""
        for (var t = 0; t < remainingLength; t++) {
          padVal = padVal + "0";
        }
        if(this.districtCheck){
          if(this.sequenceeTemplateForm.get('prefix').value == "District")
            fText ="ERODE"+""+fText + "" +padVal + ""+numVal;
          else
          fText =fText + "" + padVal + "" +"ERODE"+ "" +numVal;
        }else{
          fText =fText + "" + padVal + "" + numVal;
        }
        
      }



      if (this.sequenceeTemplateForm.get('type').value == "branchbased") {
        this.previewArrayText.length = 0;
        this.branchList.forEach(element => {
          let ptext = element.branchCode + "/" + fText.toUpperCase();
          let previewData={
            code: element.area,
            pValue:ptext
          }

          this.previewArrayText.push(previewData);
        });
      }
      else {
        this.previewArrayText.length = 0;
        let previewData={
          code: "EMPTY",
          pValue:fText.toUpperCase()
        }
        this.previewArrayText.push(previewData);
      }

    }
    //}
    this.resetCustom();

  }
  prefixchange(event) {
    if (event.length > 0) {

      let fText = "";
      let dateFormat;
      let dateValue="";
      if (this.sequenceeTemplateForm.get('format1date').value != null) {
        dateFormat = this.sequenceeTemplateForm.get('format1date').value;

        dateValue = this.datePipe.transform(Date.now(), dateFormat);
        this.datelen = dateValue.length;
      }
      else
        this.datelen = 0


      if (this.sequenceeTemplateForm.get('format1text').value != null)
        this.textlen = this.sequenceeTemplateForm.get('format1text')?.value?.length;
      else
        this.textlen = 0

      let branchCodeLength = 0;
      if (this.sequenceeTemplateForm.get('type').value == "branchbased")
        branchCodeLength = 4;
      else
        branchCodeLength = 0;
        let district =0;
        if(this.districtCheck)
          district=5;
        else
          district =0;

      if (event[0].value == "Date Format") {



        fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
        fText = dateValue + "" + fText;
        let tempCount = this.nod - branchCodeLength - district;
        let remainingLength = tempCount - fText?.length;

        let numVal = !!this.sequenceeTemplateForm.get('format1number')?.value?this.sequenceeTemplateForm.get('format1number').value:'';
        remainingLength = remainingLength - numVal?.toString()?.length;
        let padVal = ""
        for (var t = 0; t < remainingLength; t++) {
          padVal = padVal + "0";
        }
        if(this.districtCheck){
        fText = fText + "" + padVal + "" +"ERODE"+numVal;}
        else{
          fText = fText + "" + padVal + "" + numVal;

        }

      }
      else {
        fText = !!this.sequenceeTemplateForm.get('format1text').value?this.sequenceeTemplateForm.get('format1text').value:'';
        fText = fText + "" + dateValue;
        let tempCount = this.nod - branchCodeLength -district;
        let remainingLength = tempCount - fText?.length;

        let numVal = !!this.sequenceeTemplateForm.get('format1number')?.value?this.sequenceeTemplateForm.get('format1number').value:'';
        remainingLength = remainingLength - numVal?.toString()?.length;
        let padVal = ""
        for (var t = 0; t < remainingLength; t++) {
          padVal = padVal + "0";
        }
        if(this.districtCheck){
          if(event[0].value == "District")
           fText = 'ERODE'+ "" +fText + "" + padVal + "" + numVal;
        else 
          fText = fText + "" + padVal + ""+'ERODE'+ numVal; 
        }
        else
         fText = fText + "" + padVal + "" + numVal;

      }
      if (this.sequenceeTemplateForm.get('type').value == "branchbased") {
        this.previewArrayText.length = 0;
        this.branchList.forEach(element => {
          let ptext = element.branchCode + "/" + fText.toUpperCase();
          let previewData={
            code: element.area,
            pValue:ptext
          }

          this.previewArrayText.push(previewData);
        });
      }
      else {
        this.previewArrayText.length = 0;
        let previewData={
          code: "EMPTY",
          pValue:fText.toUpperCase()
        }
        this.previewArrayText.push(previewData);
      }
    }
    else
    {
      this.numberchange();
    }
    this.resetCustom();
  }
  limitCheck() {
    let dateFormat = this.sequenceeTemplateForm.get('format1date').value;
    let dateValue = this.datePipe.transform(Date.now(), dateFormat);
    if (dateValue != null && dateValue != undefined)
      this.datelen = dateValue.length;
    else
      this.datelen = 0;
    if (this.sequenceeTemplateForm.get('format1text').value != null)
      this.textlen = this.sequenceeTemplateForm.get('format1text').value.length;
    else
      this.textlen = 0;
    let branchCodeLength = 0;
    if (this.sequenceeTemplateForm.get('type').value == "branchbased")
      branchCodeLength = 4;
    else
      branchCodeLength = 0;

      let district =0;
      if(this.districtCheck)
        district=5;
      else
        district =0;


    if (this.textlen + this.datelen + branchCodeLength + district + this.numlen<= (this.nod)) {
      this.limitflag = false;
      this.datelimitflag = false;
      this.nodLimitflag = false;
      this.numlimitflag = false;
    }
    //this.numberchange();
  }
  onDelete(event){
  event.target.disabled=true;
  let key='REG'
  let tenantId = '20b004ac-73bf-41bd-f0ab-08dbc4967c24'
  this.seqTemplateSrvc.delete(`${this.apiUrl}/tenants/${tenantId}/seqtemplate/${key}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
  }, (error) => {
    event.target.disabled=false;
  },()=>{
    event.target.disabled=false;
    this.deleteFlag=true;
    setTimeout(()=>{
      this.deleteFlag=false;
    },4000)
  })
}

  onSave() {
    this.isErrorMsg = false;
    this.isDateErrorMsg = false;
    this.nodLimitflag = false;
    this.isTextErrorMsg = false;
    this.setNumberValidation = false;
    this.isSubmitted = true;
    //this.sortOrder = this.getSortOrder();


    // this.numberStart = this.getNumberStart();
    this.numberStart = this.sequenceeTemplateForm.get('format1number').value
    if (this.numberStart == undefined || this.numberStart == null) {
      this.setNumberValidation = true;
    }
    //this.textFormat = this.getTextFormat();
    this.textFormat = this.sequenceeTemplateForm.get('format1text').value
    //this.dateFormat = this.getDateFormat();
    this.dateFormat = this.sequenceeTemplateForm.get('format1date').value

    if (this.typeOptions.length >= 0) {
      var text = this.typeOptions.filter(element => 1 == element.value);
      var date = this.typeOptions.filter(element => 2 == element.value);
      if (text.length > 0) {
        if (this.textFormat != null && this.textFormat != undefined && this.textFormat != "")
          this.isTextErrorMsg = false;
        else
          this.isTextErrorMsg = true;
      }
      else
        this.isTextErrorMsg = false;

      if (date.length > 0) {
        if (this.dateFormat != null && this.dateFormat != undefined)

          this.isDateErrorMsg = false;
        else
          this.isDateErrorMsg = true;
      }
      else
        this.isDateErrorMsg = false;

      if (this.typeOptions.length >= 2) {
        if (this.sequenceeTemplateForm.get('prefix').value != null && this.sequenceeTemplateForm.get('prefix').value != undefined)
          this.isErrorMsg = false;
        else
          this.isErrorMsg = true;
      }
      else
        this.isErrorMsg = false;

    }
    let branchCodeLength = 0;
    if (this.sequenceeTemplateForm.get('type').value == "branchbased")
      branchCodeLength = 4;
    else
      branchCodeLength = 0;
      let datelength=0;
      if (this.sequenceeTemplateForm.get('format1date').value != null) {
        let dateFormat = this.sequenceeTemplateForm.get('format1date').value;
  
        let dateValue = this.datePipe.transform(Date.now(), dateFormat);
        datelength = dateValue.length;
      }
      else
        datelength = 0;

    if ((this.isErrorMsg || this.isDateErrorMsg || this.isTextErrorMsg) ) {
     
      return;
    }
    else if( (this.nod !=( this.sequenceeTemplateForm.get('format1text').value?.length) + datelength+ this.numlen + (!!this.districtCheck?5:0) + branchCodeLength) && this.nod !== 8 && this.nod !== 12){
      this.fieldCheck = true;
      setTimeout(()=>{this.fieldCheck=false;},4000)
      return 
    }
    else {
      if (this.typeOptions?.length > 0) {

        let dateFormat = this.sequenceeTemplateForm.get('format1date').value;
        let dateValue = this.datePipe.transform(Date.now(), dateFormat);
        this.datelen = dateValue.length;
        if (this.sequenceeTemplateForm.get('format1text').value != null)
          this.textlen = this.sequenceeTemplateForm.get('format1text').value?.length;
        else
          this.textlen = 0;
        if (this.textlen + this.datelen > (this.nod - 1)) {
          this.nodLimitflag = true;
          return;
        }


        if (this.typeOptions.length == 1) {
          if (this.datecheck)
            this.sortOrder = "DN";
          else if (this.districtCheck)
            this.sortOrder = "AN";
          else if (this.textcheck)
            this.sortOrder = "TN";
        }
        if (this.typeOptions.length == 2) {
          if (this.textcheck && this.datecheck)
            this.sortOrder = this.sequenceeTemplateForm.get('prefix').value == "Date Format"? "DTN":"TDN";
          else if (this.textcheck && this.districtCheck)
            this.sortOrder = this.sequenceeTemplateForm.get('prefix').value == "District"? "ATN":"TAN";
          else if (this.datecheck && this.districtCheck)
            this.sortOrder = this.sequenceeTemplateForm.get('prefix').value == "District"? "ADN":"DAN";
        }
        if (this.typeOptions.length == 3) {
          if (this.sequenceeTemplateForm.get('prefix').value == "Text")
            this.sortOrder ="TDAN";
          else if (this.sequenceeTemplateForm.get('prefix').value == "Date Format")
            this.sortOrder = "DTAN";
          else if (this.sequenceeTemplateForm.get('prefix').value == "District")
            this.sortOrder ="ATDN";
        }
      }
      else {
        this.sortOrder = "N";
      }
      if (this.isDataAlreadyExits(this.sequenceeTemplateForm.get('pageList').value)) {
        let key = this.sequenceeTemplateForm.get('pageList').value;
        const sep = (!!this.FormattedText||this.FormattedText?.length > 0)? this.extractSeparators(this.previewArrayText[0]?.pValue,this.FormattedText):null;
        this.saveData = {
          textDesc: this.textFormat.toUpperCase(),
          dateFormat: this.dateFormat,
          numberStart: this.numberStart,
          length: this.nod,
          //padCharacter: this.sequenceeTemplateForm.get('pad').value,
          padCharacter: "0",
          //increment: this.sequenceeTemplateForm.get('increment').value,
          increment: 1,
          currentValue: this.currentVal,
          userId: "admin",
          entryDatatime: this.currentdate,
          sortOrder: this.sortOrder,
          tenantId: this.tenantId,
          generateSequenceBy: this.districtCheck==true?'districtbased':null,
          branchDataList: this.sequenceeTemplateForm.get("type").value == "tenantbased" ? null : this.branchCodeList,
          type: this.sequenceeTemplateForm.get("type").value,
          Separator:!!sep?JSON.stringify(sep):null
        }
        this.seqTemplateSrvc.update(`${this.apiUrl}/tenants/${this.tenantId}/seqtemplate/edit/${key}`, this.saveData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        }, (error) => {
          this.isSubmitted = false;

        }, () => {
          this.isSubmitted = false;
          this.updateLabel = true;
          setTimeout(() => {
            this.updateLabel = false;
          }, 2000);
          //   this.tstSrvc.ForSuccess('Data updated');

          this.isPreview = true;
          this.fetchSeqTemplate();
        });
      }
      else {
          const sep = (!!this.FormattedText||this.FormattedText?.length > 0)? this.extractSeparators(this.previewArrayText[0]?.pValue,this.FormattedText):null;
        this.saveData = {
          textDesc: this.textFormat.toUpperCase(),
          dateFormat: this.dateFormat,
          numberStart: this.numberStart,
          length: this.nod,
          padCharacter: "0",
          increment: 1,
          currentValue: 0,
          keyword: this.sequenceeTemplateForm.get('pageList').value,
          userId: "admin",
          entryDatatime: this.datetime,
          sortOrder: this.sortOrder,
          tenantId: this.tenantId,
          branchDataList: this.sequenceeTemplateForm.get("type").value == "tenantbased" ? null : this.branchCodeList,
          type: this.sequenceeTemplateForm.get("type").value,
          generateSequenceBy: this.districtCheck==true?'districtbased':null,
          Separator:!!sep?JSON.stringify(sep):null
        }
        this.seqTemplateSrvc.create(`${this.apiUrl}/tenants/${this.tenantId}/seqtemplate`, this.saveData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        }, (error) => {
          this.isSubmitted = false;
        }, () => {
          this.isSubmitted = false;
          this.successLabel = true;
          setTimeout(() => {
            this.successLabel = false;
          }, 2000);
          this.fetchSeqTemplate();
        });

      }
    }

  }
  onPreClick(){
    const text = this.textcheck;
    const district = this.districtCheck;
    const date = this.datecheck;
    if (!!text && !this.typeOptions.some(x => x?.value === 1 && x?.title === "Text")) {
        this.typeOptions.push({ "title": "Text", "value": 1 });
    } else if (!!district && !this.typeOptions.some(x => x?.value === 3 && x?.title === "District")) {
        this.typeOptions.push({ "title": "District", "value": 3 });
    } else if (!!date && !this.typeOptions.some(x => x?.value === 2 && x?.title === "Date Format")) {
        this.typeOptions.push({ "title": "Date Format", "value": 2 });
    }
    if (this.typeOptions.length === 0 || !this.typeOptions.some(x => x?.title === "Text") && 
        !this.typeOptions.some(x => x?.title === "District") && !this.typeOptions.some(x => x?.title === "Date Format")) {
        this.textcheck = false;
        this.districtCheck = false;
        this.datecheck = false;}
  } 
  

resetCustom(){
  this.Customization = false;
  this.FormattedText = null;
}

applySeparators(original: string, rules: { S: string; I: number }[]): string {
  // sort by index so order is correct
  const sorted = [...rules].sort((a, b) => a.I - b.I);
  let text = original;

  // insert from right to left (so indices don’t shift)
  for (let k = sorted.length - 1; k >= 0; k--) {
    const { S, I } = sorted[k];
    if (I >= 0 && I <= text.length) {
      text = text.slice(0, I) + S + text.slice(I);
    }
  }

  return text;
}

  
extractSeparators(original: string, formatted: string): { S: string; I: number }[] {
  const result: { S: string; I: number }[] = [];
  let originalIndex = 0;

  for (let i = 0; i < formatted?.length; i++) {
    if (originalIndex < original?.length && formatted[i] === original[originalIndex]) {
      // move along original if char matches
      originalIndex++;
    } else {
      // store index based on original, not formatted
      result.push({ S: formatted[i], I: originalIndex });
    }
  }

  return result;
}
allowedSpecials =  ["-", "/", ".", "_", ":", "|", "#", "*", "+", "~"];


onInputChange(event: any) {
  const originalText: string = this.previewArrayText[0]?.pValue || '';
  let value: string = event?.target?.value;

  if (!value) {
    this.FormattedText = originalText;
    event.target.value = originalText;
    return;
  }

  let cleaned = '';
  let origIndex = 0;

  for (let i = 0; i < value.length; i++) {
    const ch = value[i];

    if (origIndex < originalText.length && ch === originalText[origIndex]) {
      cleaned += ch;
      origIndex++;
    } else if (this.allowedSpecials.includes(ch)) {
      if (cleaned?.length > 0 && !this.allowedSpecials?.includes(cleaned[cleaned?.length - 1])) {
        cleaned += ch;
      }
    }
  }
  if (origIndex < originalText.length) {
    cleaned += originalText.substring(origIndex);
  }
  cleaned = cleaned.replace(new RegExp(`[${this.allowedSpecials.join('')}]$`), '');
  this.FormattedText = cleaned;
  event.target.value = cleaned;
}



isView: boolean= false;
isPageEdit: boolean= false;
isCreate: boolean= false;
isEdit: boolean= false;
isPrint: boolean= false;
isExport: boolean= false;
isPageDelete: boolean=false;
pageTaskIds: any = [];
userAccessData: Array<any>=[];

pageaccess(){
        this.pageTaskIds =[];
         this.pageTaskIds.push(access.task.UID_GEN);
        let matrixSearchData={
          taskId: this.pageTaskIds,
          UserId:localStorage.getItem("userType")
        }
        this.rolesService.create(`${this.apiUrl}/userrole/${this.tenantId}/${this.branchId}/pageaccesssearch`, matrixSearchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.userAccessData = data;
        }, (error) => {
        }, () => {
          this.isCreate = this.userAccessData.some(element =>
              (access.task.UID_GEN === element.taskID) &&
              element.actionID === access.action.CREATE &&
              element.permission === "true"
          );
    
        });
      }




}

export function NumberFormatExistsValidator(format1: string, format2: string, format3: string): ValidationErrors | null {
  return (group: FormGroup) => {
    let format1Input = group.controls[format1];
    let format2Input = group.controls[format2];
    let format3Input = group.controls[format3];
    if (format1Input.value != "Number" && format2Input.value != "Number" && format3Input.value != "Number") {
      return { 'numberExist': true }
    }
    else {
      return null
    }
  }

}

export function format1Validator(format1: string, format1date: string, format1number: string, format1text: string): ValidationErrors | null {
  return (group: FormGroup) => {
    let f1 = group.controls[format1].value;
    let txt = group.controls[format1text].value
    let num = group.controls[format1number].value
    let date = group.controls[format1date].value
    if (f1 == "Date Format") {
      if (date == null || date == undefined || date == "") {
        return { 'format1DateValid': true }
      }
    }
    else if (f1 == "Text Format") {
      if (txt == null || txt == undefined || txt == "") {
        return { 'format1TxtValid': true }
      }
    }
    else if (f1 == "Number") {
      if (num == null || num == undefined || num == "") {
        return { 'format1NumValid': true }
      }
    }
    else {
      return null
    }

  }
}
export function format2Validator(format2: string, format2date: string, format2number: string, format2text: string): ValidationErrors | null {
  return (group: FormGroup) => {
    let f2 = group.controls[format2].value;
    let txt = group.controls[format2text].value
    let num = group.controls[format2number].value
    let date = group.controls[format2date].value
    if (f2 == "Date Format") {
      if (date == null || date == undefined || date == "") {
        return { 'format2DateValid': true }
      }
    }
    else if (f2 == "Text Format") {
      if (txt == null || txt == undefined || txt == "") {
        return { 'format2TxtValid': true }
      }
    }
    else if (f2 == "Number") {
      if (num == null || num == undefined || num == "") {
        return { 'format2NumValid': true }
      }
    }
    else {
      return null
    }

  }
}

export function format3Validator(format3: string, format3date: string, format3number: string, format3text: string): ValidationErrors | null {
  return (group: FormGroup) => {
    let f3 = group.controls[format3].value;
    let txt = group.controls[format3text].value
    let num = group.controls[format3number].value
    let date = group.controls[format3date].value
    if (f3 == "Date Format") {
      if (date == null || date == undefined || date == "") {
        return { 'format3DateValid': true }
      }
    }
    else if (f3 == "Text Format") {
      if (txt == null || txt == undefined || txt == "") {
        return { 'format3TxtValid': true }
      }
    }
    else if (f3 == "Number") {
      if (num == null || num == undefined || num == "") {
        return { 'format3NumValid': true }
      }
    }
    else {
      return null
    }

  }
}



